var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubblesInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.8 34.3V82.6C92.8 84.2709 92.1363 85.8733 90.9548 87.0548C89.7733 88.2363 88.1709 88.9 86.5 88.9H27.9L8 108.8V34.3C8.02578 32.6372 8.69781 31.0497 9.87375 29.8737C11.0497 28.6978 12.6372 28.0258 14.3 28H86.5C88.1628 28.0258 89.7503 28.6978 90.9263 29.8737C92.1022 31.0497 92.7742 32.6372 92.8 34.3Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 73.7001V77.3001H41.5V73.7001H44.2C44.4975 73.7004 44.792 73.6404 45.0657 73.5236C45.3393 73.4068 45.5864 73.2358 45.7921 73.0208C45.9977 72.8058 46.1576 72.5513 46.2621 72.2727C46.3666 71.9942 46.4135 71.6973 46.4 71.4001V59.5001C46.4135 59.2029 46.3666 58.906 46.2621 58.6275C46.1576 58.3489 45.9977 58.0944 45.7921 57.8794C45.5864 57.6644 45.3393 57.4934 45.0657 57.3766C44.792 57.2598 44.4975 57.1998 44.2 57.2001H41.5V53.6001H55.2V71.4001C55.1865 71.6973 55.2334 71.9942 55.3379 72.2727C55.4424 72.5513 55.6023 72.8058 55.8079 73.0208C56.0136 73.2358 56.2607 73.4068 56.5343 73.5236C56.808 73.6404 57.1025 73.7004 57.4 73.7001H59.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 43.2999C55.4133 43.9386 55.2989 44.5736 55.0637 45.1675C54.8284 45.7615 54.477 46.3025 54.0299 46.7588C53.5829 47.2152 53.0492 47.5777 52.4602 47.8252C51.8712 48.0727 51.2388 48.2 50.5999 48.1999C49.9565 48.1999 49.3193 48.0732 48.7248 47.8269C48.1303 47.5807 47.5901 47.2197 47.1351 46.7647C46.6801 46.3097 46.3192 45.7695 46.0729 45.175C45.8267 44.5806 45.7 43.9434 45.7 43.2999C45.7 42.6564 45.8267 42.0192 46.0729 41.4248C46.3192 40.8303 46.6801 40.2901 47.1351 39.8351C47.5901 39.3801 48.1303 39.0191 48.7248 38.7729C49.3193 38.5266 49.9565 38.3999 50.5999 38.3999C51.2388 38.3998 51.8712 38.5272 52.4602 38.7746C53.0492 39.0221 53.5829 39.3846 54.0299 39.841C54.477 40.2973 54.8284 40.8383 55.0637 41.4323C55.2989 42.0263 55.4133 42.6612 55.4 43.2999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6 41.7H135.1C136.771 41.7 138.373 42.3637 139.555 43.5452C140.736 44.7267 141.4 46.3291 141.4 48V121.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.4 121.9L121.6 102.1H63.5C61.8463 102.1 60.2588 101.45 59.0802 100.29C57.9015 99.1302 57.2262 97.5534 57.2 95.8999V88.3999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6 68.7H121.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6 76.8999H121.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6 60.1001H121.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6 85.1001H109.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubblesInformation);
export default __webpack_public_path__ + "static/media/speech_bubbles_information.0cf0f92a7938e08ec71a96a55fedfec8.svg";
export { ForwardRef as ReactComponent };